export default "__VITE_ASSET__Be74Q$3R__"